export default __webpack_public_path__ + "static/media/element_73.f6f2267a.jpg";